import type { AppConfig } from '@/types/config';

// TODO: This is not the best solution, NEED TO FIND A BETTER ONE
export const getConfig = (): AppConfig => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
    const { config } = require(
        `@/../config/env/${process.env.BRAND}-${process.env.PRODUCT}-${process.env.COUNTRY}/${process.env.CONFIG_ENV}.js`
    );
    return config as AppConfig;
};
